<template>
  <div v-if="isLogged">
    <v-layout id="user-details-box" mt-6 mb-6 wrap justify-space-between>
      <v-flex class="user-details" xl6 lg6 md5 sm12 xs12>
        <UserPersonalDetails />
      </v-flex>

      <v-flex class="user-fav-job" xl5 lg5 md6 sm12 xs12 justify-center>
        <nuxt-link to="/personal/history">
          <FavJobsBox
            :counter="HistoryCount"
            :title="t(`titles.candidates.sentCvTitle`)"
            :link-title="t(`titles.candidates.showAllSentCvTitle`)"
          />
        </nuxt-link>
        <nuxt-link to="/myjobs">
          <FavJobsBox
            :counter="JobBasket.length"
            :title="t(`titles.candidates.favJobsTitle`)"
            :link-title="t(`titles.candidates.showAllFavJobsTitle`)"
          />
        </nuxt-link>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex>
        <UserPersonalDetailsEdit />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FavJobsBox from '@/components/Candidates/UserDetails/FavJobsBox'
import UserPersonalDetails from '@/components/Candidates/UserDetails/UserPersonalDetails'
import UserPersonalDetailsEdit from '@/components/Candidates/UserDetails/UserPersonalDetailsEdit'

export default {
  components: {
    FavJobsBox,
    UserPersonalDetails,
    UserPersonalDetailsEdit
  },
  data() {
    return {
      cvSendModel: null,
      sentCvHistoryCount: 0
    }
  },

  computed: {
    ...mapGetters(['JobBasket', 'JobHistory', 'isLogged']),

    HistoryCount() {
      return Object.keys(this.JobHistory).length
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
#user-details-box .v-input--selection-controls__ripple .send-cv-check {
  position: static;
}

#user-details-box {
  background-color: #f6f7f9;
  padding: 8px 5px;
}

.user-name {
  display: inline-flex;
}

.mob-none {
  display: none;
}

.user-fav-job {
  display: flex;
}

@media only screen and (min-width: 600px) {
  #user-details-box {
    padding: 16px 16px;
  }

  .mob-none {
    display: block;
  }

  .pc-none {
    display: none;
  }
}
</style>
